// @ts-nocheck
import { useTranslation } from 'react-i18next'

import EntityAddEditForm from 'js/components/EntityActions/EntityAddEditForm'

import { TASKS_LIST } from './Tasks/Tasks.queries'

const Add = () => {
    const refetchQueries = [TASKS_LIST]
    const { t } = useTranslation()

    return (
        <EntityAddEditForm
            title={t('entity-task.create')}
            subtype="task"
            refetchQueries={refetchQueries}
        />
    )
}

export default Add
